import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const SignupPage: React.FC = () => {
  const { isAuthenticated, redirectToSignup } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSignup = () => {
    redirectToSignup();
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="text-center mb-4">
                <img
                  src="/ratemytalk150.png"
                  alt="RateMyTalk Logo"
                  height="80"
                  className="mb-3"
                />
                <h2 className="card-title">Join RateMyTalk</h2>
                <p className="text-muted">Create your account to get started</p>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light">
                    <div className="card-body text-center">
                      <i className="fas fa-microphone text-primary mb-2"></i>
                      <h6 className="card-title">For Speakers</h6>
                      <small className="text-muted">
                        Create talks, get feedback, track sessions
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light">
                    <div className="card-body text-center">
                      <i className="fas fa-calendar text-primary mb-2"></i>
                      <h6 className="card-title">For Organizers</h6>
                      <small className="text-muted">
                        Manage events, invite speakers, view analytics
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-grid gap-2">
                <button
                  className="btn btn-primary btn-lg"
                  onClick={handleSignup}
                >
                  <i className="fas fa-rocket me-2"></i>
                  Create Account with Cognito
                </button>
              </div>

              <hr className="my-4" />

              <div className="text-center">
                <p className="mb-0">
                  Already have an account?{' '}
                  <button
                    className="btn btn-link p-0"
                    onClick={handleLogin}
                  >
                    Sign in here
                  </button>
                </p>
              </div>

              <div className="mt-4">
                <div className="alert alert-success">
                  <i className="fas fa-shield-alt me-2"></i>
                  <strong>Secure & Private:</strong> Your data is protected with
                  enterprise-grade security. We support MFA including hardware tokens.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
